import { createStore, createEvent } from 'effector';
import { LocalStorageUtils } from '@shared/utils';

const setIsCollapsedEvent = createEvent<boolean>();
const toggleMenuEvent = createEvent();
const clearEvent = createEvent();

const $store = createStore<boolean>(LocalStorageUtils.getMenuIsCollapsed())
  .on(setIsCollapsedEvent, (_, data) => data)
  .on(toggleMenuEvent, (state) => !state)
  .reset(clearEvent);
$store.watch((isCollapsed) => LocalStorageUtils.setMenuIsCollapsed(isCollapsed));

export const $menuStore = {
  events: {
    setIsCollapsed: setIsCollapsedEvent,
    toggleMenu: toggleMenuEvent,
    clear: clearEvent,
  },
  store: $store,
};
